import { defineComponent as o } from "vue";
const n = /* @__PURE__ */ o({
  __name: "dropdown-container",
  props: {
    showRight: { type: Boolean },
    autoWidth: { type: Boolean },
    uid: { default: void 0 },
    isMultiSelect: { type: Boolean }
  },
  setup(e) {
    return { __sfc: !0 };
  }
});
export {
  n as default
};
